// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "immutable/" + chunkId + "." + {"1134":"8e063ea4e72b5ee30bd4","2023":"05a086dfa257fd19a951","2460":"80c9cb17417927da2a31","5451":"e56820f89bfb32e067e3"}[chunkId] + ".chunk.css";
};